import { Component } from '@angular/core';

@Component({
    selector: 'app-notifications-page',
    templateUrl: './notifications-page.component.html',
    styleUrls: ['./notifications-page.component.css'],
    standalone: false
})
export class NotificationsPageComponent {

}
